export default {
    ATENDIMENTO_PROGRAMADO: 6,
    ATENDIMENTO_NAO_PROGRAMADO: 7,
    VISITA_DOMICILIAR_POS_OBITO: 8
}